import React, { useState } from 'react';
import { ModalContainer, Item, Label } from '../style';
import Select from 'components/FormElements/Select';
import { Button, Input } from 'antd';
// import DatePicker from 'components/DatePicker';
import { DatePicker } from 'antd';
import moment from 'moment';

const SpecialModal = ({ groups = [], handleClick }) => {
  const [postData, setPostData] = useState({});
  const [singleDate, setSingleDate] = useState(moment().format('YYYY-MM-DD'));

  const handleClickCreateTask = () => {
    handleClick({ ...postData, singleDate });
  };

  const handleChangeDateInput = (_, dateString) => {
    const data = moment(dateString).format('YYYY-MM-DD');
    setSingleDate(data);
  };

  return (
    <ModalContainer>
      <Item>
        <Select
          handleChange={(value) => {
            setPostData({ ...postData, ['group']: value });
          }}
          name='group'
          options={groups}
          defaultVal={postData.group}
          title='Гуруҳ'
        />
      </Item>
      <Item>
        <Label>Номи</Label>
        <Input
          onChange={(e) => {
            setPostData({ ...postData, ['title']: e.target.value });
          }}
          value={postData?.title}
        />
      </Item>
      <Item>
        <div className='date-container'>
          <Label>Санани танланг</Label>
          {/* <DatePicker withTitle={false} /> */}
          <DatePicker
            defaultValue={moment(singleDate)}
            format='DD MMM YYYY'
            onChange={handleChangeDateInput}
          />
        </div>
      </Item>
      <Item>
        <Button
          type='primary'
          disabled={!postData.group || !postData?.title}
          onClick={handleClickCreateTask}
          style={{
            height: '40px',
            background: '#3380FF',
            borderRadius: '10px',
            padding: '0 40px',
          }}
        >
          Топшириқ яратиш
        </Button>
      </Item>
    </ModalContainer>
  );
};

export default SpecialModal;
